<fm-device-health-check [statusItem]="statusItem$ | async"
  [esn]="(statusItem$ | async)?.type === EPlotType.asset ? (statusItem$ | async)?.esn : (vehicleWithEsn$ | async)?.esn"
  [boxType]="(statusItem$ | async)?.type === EPlotType.asset ? '' : (vehicleWithBox$ | async)?.boxType"
  [userSettings]="userSettings$ | async"
  [accountId]="accountId$ | async"
  [pingState]="pingState$ | async"
  [resetState]="resetState$ | async"
  [history]="history$ | async"
  [historyLoading]="historyLoading$ | async"
  [userPermissions]="userPermissions$ | async"
  (sendPingClicked)="initiateHealthCheck($event)">
</fm-device-health-check>